import { render, staticRenderFns } from "./UsersListView.html?vue&type=template&id=68c54f70&scoped=true&"
import script from "./UsersListView.js?vue&type=script&lang=js&"
export * from "./UsersListView.js?vue&type=script&lang=js&"
import style0 from "./UsersListView.scss?vue&type=style&index=0&id=68c54f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c54f70",
  null
  
)

export default component.exports